/* eslint-disable import/prefer-default-export */
import styled from 'react-emotion';
import { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export const EditorContainer = styled('div')`
  box-sizing: border-box;
  position: relative;
  left: -80px;
  width: calc(100% + 110px);
  padding-top: 20px;
  padding-left: 28px;
  padding-right: 28px;
  height: 100%;

  &:hover {
    background-color: ${({ hoverable }) =>
      hoverable ? colors.grayLight : 'initial'};
  }
  &:focus-within {
    background-color: initial;
  }

  .RichEditor-editor {
    padding-bottom: 56px !important; // Override a Radium-based style to avoid material content cutting off
  }
`;
